import { SoloCardComponent } from "./components/solo-card/solo-card.component";
import { AppComponent } from "./app.component";
import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { StepperExampleComponent } from "./components/stepper/stepper.component";
import { DashboardComponent } from "./components/dashboard/dashboard.component";
import { FormFieldsComponent } from "./components/form-fields/form-fields.component";
import { GridComponent } from "./components/grid/grid.component";
import { ControlsComponent } from "./components/controls/controls.component";

const routes: Routes = [
  { path: "forbidden", component: AppComponent },
  { path: "unauthorized", component: AppComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      [
        ...routes,
        { path: "", component: DashboardComponent },
        { path: "dashboard", component: DashboardComponent },
        { path: "formfields", component: FormFieldsComponent },
        { path: "controls", component: ControlsComponent },
        { path: "grid", component: GridComponent },
        { path: "solo-card", component: SoloCardComponent },
        {
          path: "**",
          redirectTo: "",
        },
      ],
      { anchorScrolling: "enabled" }
    ),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
